/*
 * EINE SITZUNG, DIE NICHTS MEHR ANNIMMT, BRAUCHT EINEN KNOPF — NICHT NUR EINE WARNUNG
 * (Sahori Seefoo, 24.09. und 07.10.2026: „the Kanzler is receiving messages that dissappear").
 *
 * Gemessen am 07.10.2026 (Haus Partner, Kanzler 61a0c97b): der letzte Zug vom 06.10. 16:42:51Z
 * endete nie (kein stop_hook_summary im Verlauf), der Prozess lebte weiter und galt als „idle".
 * Ihre drei Nachrichten von 09:16, 09:35 und 10:22Z wurden in ihn geschrieben (`Piped to existing
 * process`, Journal `written`), kamen aber nie im Verlauf an — bis der Prozess um 11:43Z von
 * aussen beendet wurde. Seit 09.10. (372a75c9e) zeigt der Kopf „Keine bestätigte Übernahme –
 * bitte prüfen"; was sie dann tun kann, stand nirgends.
 *
 * Der Weg, den es schon gibt: „Stop" haelt den Prozess an (die nicht uebernommenen Nachrichten
 * werden dabei laut als verloren vermerkt, HS5), die naechste Nachricht startet die Sitzung frisch
 * mit vollem Verlauf. Angeboten wird er nur, wenn es wirklich nach Haengen aussieht:
 *  - der Server meldet `delayed` (offene Eingabe > 2 min UND > 2 min keine Ausgabe),
 *  - kein Werkzeug laeuft (ein langer Build ist kein Haengen und wird nie angeboten abzubrechen),
 *  - die aelteste offene Eingabe ist mindestens HAENGT_AB_MS alt — dieselbe Grenze, ab der der
 *    Server eine nie bestaetigte Eingabe als verloren behandelt (UNBESTAETIGT_MAX_MS, claude-cli.ts).
 * Automatisch angehalten wird nichts: ein lebender Prozess wird nur auf ausdruecklichen Klick beendet.
 */
export const HAENGT_AB_MS = 10 * 60 * 1000;

export type Zustellstand = {
  pending: number;
  delayed: boolean;
  toolRunning?: boolean;
  deliveries?: { at: number; state: string }[];
};

export function uebernahmeHaengt(s: Zustellstand | null | undefined, jetzt: number = Date.now()): boolean {
  if (!s || s.pending <= 0 || !s.delayed || s.toolRunning) return false;
  const offen = (s.deliveries ?? []).filter(d => d.state !== 'received' && d.state !== 'verfallen' && typeof d.at === 'number');
  if (!offen.length) return false;
  const aelteste = Math.min(...offen.map(d => d.at));
  return jetzt - aelteste >= HAENGT_AB_MS;
}
